import LoadModal from './LoadModal';

export default LoadModal;
